import * as type from './types';
import exceljs from "exceljs";
import {Defitems} from "./lib/api/api_response_type";

export const messegeCloseTime = {
    "Error":5000,
    "Info":3000,
}

export const messegeColor ={
    "Error":"red",
    "Warnig":"orange darken-2",
    "Sccess":"cyan lighten-4",
}

export const notConnectError = {
    "httpStatus":1,
    "code":1
} as type.errorDetail
export const unknowError = {
    "httpStatus":0,
    "code":0
} as type.errorDetail

export const invalidSession = (vueRef:any) => {
    vueRef.$emit("parentCall","invalidSession");
}

export const LoadingOverlay = (vueRef:any,sw:boolean) => {
    if(sw){
        vueRef.$emit("parentCall","loadingON");
    }else{
        vueRef.$emit("parentCall","loadingOFF");
    }
}

export const SuccessMessege = (vueRef:any,messege:string,appRoot=false) => {
    vueRef.$store.commit("setSysMessege",{
        "color":messegeColor.Sccess,
        "text":messege,
        "timeout":messegeCloseTime.Info,
    });
    if(appRoot){
        vueRef.appCall("systemMessege");
    }else{
        vueRef.$emit("parentCall","systemMessege");
    }
}
export const WaringMessege = (vueRef:any,messege:string,timeout?:number|null,appRoot=false) => {
    vueRef.$store.commit("setSysMessege",{
        "color":messegeColor.Warnig,
        "text":messege,
        "timeout":typeof timeout === "number"?timeout:messegeCloseTime.Info,
    });
    if(appRoot){
        vueRef.appCall("systemMessege");
    }else{
        vueRef.$emit("parentCall","systemMessege");
    }
}
export const ApiErrorMessege = (vueRef:any,response:type.errorDetail,appRoot=false) => {
    const errorInfo = {
        code:0,
        messege:"",
    }
    if(!response){
        errorInfo.code = 500000;
        errorInfo.messege = vueRef.text.errorMessege[0];
    }else{
        errorInfo.code = response.code;
        errorInfo.messege = typeof vueRef.text.errorMessege[errorInfo.code] === "string"?vueRef.text.errorMessege[errorInfo.code]:vueRef.text.errorMessege[0]
    }
    vueRef.$store.commit("setSysMessege",{
        "color":messegeColor.Error,
        "text":`Error[${errorInfo.code}]:<br>${errorInfo.messege}`,
        "timeout":messegeCloseTime.Error,
    });
    if(typeof vueRef.appCall === "function"){
        vueRef.appCall("systemMessege");
    }else{
        vueRef.$emit("parentCall","systemMessege");
    }
}

export const SnackbarMessege = (vueRef:any,messege:string,color:string,appRoot=false,timeout?:number) => {
    vueRef.$store.commit("setSysMessege",{
        "color":color,
        "text":messege,
        "timeout":typeof timeout === "number"?timeout:messegeCloseTime.Info,
    });
    if(appRoot){
        vueRef.appCall("systemMessegeSnack");
    }else{
        vueRef.$emit("parentCall","systemMessegeSnack");
    }
}


export const formatDate = (date:Date,format:string) => {
    format = format.replace(/yyyy/g, date.getFullYear().toString());
    format = format.replace(/mm/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/mn/g, ((date.getMonth() + 1).toString()));
    format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/MM/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/SS/g, ('0' + date.getSeconds()).slice(-2));
    format = format.replace(/sss/g, ('00' + date.getMilliseconds()).slice(-3));
    return format;
}

export const contentDispositionFilenameReg = new RegExp(`filename=[\\"\\'](.+)[\\"\\']`);

export const strReplacePercentObject = (str:string,replaceObj:{[key:string]:string|number}) => {
    const split = str.split(new RegExp(`(%[^\x20]+\x20|%\x20)`));
    let replaceStr = "";
    split.forEach(v=>{
        const percent = v.match(new RegExp(`^%(.+)\x20$`));
        if(percent){
            if(replaceObj[percent[1]]){
                replaceStr += replaceObj[percent[1]];
            }
        }else if(v==="%\x20"){
            replaceStr += "%";
        }else{
            replaceStr += v;
        }
    });
    return replaceStr;
}

export const getGengou = (d:Date) => {
    const gengou = [
        {
            start:1556636400000,
            end:null,
            name:"令和",
            shortAplha:"R",
        },
        {
            start:600188400000,
            end:1556636400000,
            name:"平成",
            shortAplha:"H",
        },
        {
            start:-1357603200000,
            end:600188400000,
            name:"昭和",
            shortAplha:"S",
        }
    ]
    const dTime = d.getTime();
    for(const v of gengou){
        if(v.start <= dTime && (v.end === null || v.end > dTime)){
            const oDate = new Date(v.start);
            const oYear = d.getFullYear() - oDate.getFullYear() + 1;
            return {year:oYear,name:v.name,shortAplha:v.shortAplha};
        }
    }
    return null;
}

export const defKeyCommand = new RegExp("^#([\\+\\-\\*\\/])([0-9]+)$");

export const parseFloatE = (tgt:any) =>{
    let _tgt = tgt;
    if(typeof tgt === "string"){
        _tgt = parseFloat(tgt);
        if(isNaN(_tgt)){
            _tgt = tgt;
        }
    }
    return _tgt;
}

const getObjectPropValueOr = <T>(obj:Defitems,key:number|undefined,undefValue:T) => {
    if(!obj || !key){return undefValue}
    const itemData = obj.find(v=>v.itemCode===key)
    if(typeof itemData !== "undefined"){
        return itemData.value;
    }else{
        return undefValue;
    }
}

const calVal = (a:string|number|null,b:string|number|null,op:"+"|"-"|"*"|"/") => {
    if(typeof a === "number" && typeof b === "number"){
        switch (op){
            case "+":
                return a+b;
            case "-":
                return a-b;
            case "*":
                return a*b;
            case "/":
                return a/b;
        }
    }else if(a && b){
        return op==="+"?a.toString()+b.toString():null;
    }else if(a===null || b===null){
        return 0;
    }else{
        return a || b;
    }
}

export const defCalculator = (cardData:type.viewDeginCard,defValues:Defitems):number|string|null => {
    const rootDefname = cardData.itemCode;
    const rootValue = getObjectPropValueOr(defValues,rootDefname,null) as null|number|string;
    if(!cardData.calc){
        return rootValue;
    }else{
        return calCalulator(cardData.calc,defValues,rootValue);
    }
}

const calCalulator = (cardData:type.viewDeginCalc,defValues:Defitems,acc:number|string|null):number|string|null => {
    const rootDefname = cardData.itemCode;
    const rootValue = typeof rootDefname === "number"?getObjectPropValueOr(defValues,rootDefname,null) as null|number|string:acc;
    let _value;
    if(!cardData.calc){
        _value = typeof cardData.itemCode === "number"?(getObjectPropValueOr(defValues,rootDefname,null) as null|number|string):cardData.num;
    }else{
        _value = calCalulator(cardData.calc,defValues,rootValue);
    }
    switch (cardData.type){
        case "+":
        case "-":
        case "*":
        case "/":
            if(typeof _value === "string" && typeof cardData.num === "number"){
                const valueOpts = _value.split(",");
                const valcVal = calVal(acc,cardData.num,cardData.type);
                if(typeof valcVal === "number"){
                    return addCuma(valcVal,parseInt(valueOpts[1],10));
                }else{
                    return valcVal;
                }
            }else{
                return calVal(acc,typeof _value !=="undefined"?_value:null,cardData.type);
            }
        case "=":
            return cardData.value?cardData.value.t:null;
        case "?":
            if(typeof cardData.value !== "undefined"){
                if(acc === cardData.num){
                    return cardData.value.t;
                }else{
                    return cardData.value.f;
                }
            }else{
                return `**Error**[calc.value undefiend]`;
            }
        case ".":
            if(acc !==null){
                return addCuma(acc,cardData.num);
            }
            return '';
        default:
            return null;
    }    
}

export const addCuma = (n:number|string,p?:number):string =>{
    let _n = n;
    if(typeof _n !== "number"){
        if(_n.indexOf(".")){
            _n = parseFloat(_n);
        }else{
            _n = parseInt(_n);
        }
    }
    if(!isNaN(_n)){
        if(p){
            return _n.toLocaleString(undefined,{"minimumFractionDigits":p});
        }else{
            return _n.toLocaleString(undefined);
        }
    }else{
        return n.toString();
    }
}

export const spacerChr = ["#","$","%","&","@",":",";","/","-","_"];
export const passwordAddDic = ["ogi","ogihara","yajima","ota","gunma"];

const formulaReg = /^=(.+)/;
export const exceljsUtils = {
    setRow : (sheet:exceljs.Worksheet,origin:{row:number,column:number},cells:Array<string|number|null>) => {
        const originCell = sheet.getCell(origin.row,origin.column);
        let cellColumn = originCell.col as unknown as number;
        const cellRow = originCell.row as unknown as number;
        if(originCell){
            for(const cellData of cells){
                if(typeof cellData === "string"){
                    const formulaMatch = cellData.match(formulaReg);
                    if(formulaMatch){
                        const formulaString = formulaMatch[1];
                        //@ts-ignore
                        sheet.getCell(cellRow,cellColumn).value = {"formula":formulaString};
                        //sheet.cell(cellRow,cellColumn).value(0);
                    }else{
                        sheet.getCell(cellRow,cellColumn).value = cellData;
                    }
                }else{
                    sheet.getCell(cellRow,cellColumn).value = cellData;
                }
                cellColumn++;
            }
        }
    },
    setRowStyle : (sheet:exceljs.Worksheet,origin:{row:number,column:number},styles:Array<exceljs.Style>) => {
        const originCell = sheet.getCell(origin.row,origin.column);
        let cellColumn = originCell.col as unknown as number;
        const cellRow = originCell.row as unknown as number;
        if(originCell){
            for(const styleData of styles){
                if(styleData.alignment){
                    sheet.getCell(cellRow,cellColumn).alignment = styleData.alignment;
                }
                if(styleData.border){
                    sheet.getCell(cellRow,cellColumn).border = styleData.border;
                }
                if(styleData.fill){
                    sheet.getCell(cellRow,cellColumn).fill = styleData.fill;
                }
                if(styleData.font){
                    sheet.getCell(cellRow,cellColumn).font = styleData.font;
                }
                if(styleData.numFmt){
                    sheet.getCell(cellRow,cellColumn).numFmt = styleData.numFmt;
                }
                if(styleData.border){
                    sheet.getCell(cellRow,cellColumn).border = styleData.border;
                }
                cellColumn++;
            }
        }
    },
    setColumnWidth: (sheet:exceljs.Worksheet,origin:{row:number,column:number},widths:Array<number>) => {
        const originCell = sheet.getCell(origin.row,origin.column);
        let cellColumn = originCell.col as unknown as number;
        const cellRow = originCell.row as unknown as number;
        if(originCell){
            for(const width of widths){
                sheet.getColumn(cellColumn).width = width;
                cellColumn++;
            }
        }
    },
    getCells:(row:exceljs.Row)=>{
        const _cells:exceljs.Cell[] = [];
        row.eachCell(v=>{
            _cells.push(v);
        });
        return _cells;
    },
    getColumns:(rows:exceljs.Row[],colnum:number)=>{
        const _cells:exceljs.Cell[] = [];
        for(const row of rows){
            _cells.push(row.getCell(colnum));
        }
        return _cells;
    },
}

export const openPdfNewWindow = async (data:string|Uint8Array) =>{
    try{
        if(typeof data === "string"){
            const pdfData = await fetch(`data:application/pdf;base64,${data}`);
            window.open(URL.createObjectURL(await pdfData.blob()));
        }else if(data instanceof Uint8Array){
            window.open(URL.createObjectURL(new Blob([data],{"type":"application/pdf"})));
        }
    }catch{
        return false;
    }
}
export const convertDateToYMD = (date:Date,flag:{y:boolean,m:boolean,d:boolean}) => {
    const y = date.getFullYear().toString();
    const m = date.getMonth()>=9?(date.getMonth()+1).toString():`0${(date.getMonth()+1).toString()}`;
    const d = date.getDate()>=10?date.getDate().toString():`0${(date.getDate()).toString()}`;
    return parseInt(`${flag.y?y:""}${flag.m?m:""}${flag.d?d:""}`,10);
}
export const convertYMDtoDate = (ymd:number,options?:{ym?:{day:number}}) => {
    let ym = false;
    if(ymd<10000){
        ymd = (ymd*100)+1;
        ym = true;
    }
    if(ymd<1000000){
        //YM⇒YMD(=01)
        ymd = (ymd*100)+1;
        ym = true;
    }
    const ymdStr = ymd.toString();
    const ymdDateYMD = {
        y:parseInt(ymdStr.substring(0,4)),
        m:parseInt(ymdStr.substring(4,6)),
        d:parseInt(ymdStr.substring(6,8)),
    }
    const _d = new Date(ymdDateYMD.y,ymdDateYMD.m-1,ymdDateYMD.d,9,0,0);
    if(ym && options?.ym){
        if(options.ym.day < 1){
            _d.setMonth(_d.getMonth()+1);
            _d.setDate(_d.getDate()-1);
        }else{
            _d.setDate(options.ym.day);
        }
    }
    if(Number.isFinite(_d.getTime())){
        return _d
    }else{
        return new Date(0);
    }
}
